(() => {
  if (window.customRecommendationDesktopCarouselV1) return;
  window.customRecommendationDesktopCarouselV1 = true;
  const initialize = () => document.querySelectorAll('product-recommendations .custom-compact-recommendations-v1').forEach((list) => {
    if (list.parentElement.classList.contains('custom-recommendation-rail-v1')) return;
    const rail = document.createElement('div');
    rail.className = 'custom-recommendation-rail-v1';
    list.before(rail);
    rail.append(list);
    const positionArrows = () => {
      const photo = list.querySelector('.card__inner');
      if (photo) rail.style.setProperty('--custom-recommendation-arrow-top', `${photo.getBoundingClientRect().height / 2}px`);
    };
    new ResizeObserver(positionArrows).observe(rail);
    positionArrows();
    ['previous', 'next'].forEach((direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'custom-recommendation-rail-v1__arrow';
      button.dataset.direction = direction;
      button.setAttribute('aria-label', direction === 'previous' ? 'Previous recommendations' : 'Next recommendations');
      button.innerHTML = `<svg viewBox="0 0 14 24" fill="none" aria-hidden="true"><path d="${direction === 'previous' ? 'M11 3 2 12l9 9' : 'm3 3 9 9-9 9'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      button.addEventListener('click', () => list.scrollBy({ left: (direction === 'previous' ? -1 : 1) * (list.clientWidth + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
      rail.append(button);
    });
  });
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; initialize(); });
  }).observe(document.body, { childList: true, subtree: true });
  initialize();
})();
